<template lang="html">
	<div class="editor">
		<div ref="toolbar" class="toolbar">
		</div>
		<div ref="editor" class="text">
		</div>
	</div>
</template>

<script>
	import E from 'wangeditor'
	export default {
		name: 'editor',
		data() {
			return {
				// uploadPath,
				editor: null,
				info_: null,
				// picEdit: {
				// 	ALT: null,
				// 	link: null
				// }
			}
		},
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			value: {
				type: String,
				default: ''
			},
			isClear: {
				type: Boolean,
				default: false
			}
		},
		watch: {
			// 触发清除文本域内容
			isClear(val) {
				if (val) {
					this.editor.txt.clear()
					this.info_ = null
				}
			},
			
			//value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
			value: function(value) {
				if (value !== this.editor.txt.html()) {
					this.editor.txt.html(this.value)
				}
			},
		},
		mounted() {
			this.seteditor()
			// this.editor.txt.html(this.value)
			// sendThis(this)
		},
		methods: {
			/* showSource() {
				let _this = this
				let _editor = _this.editor
				let _source = _editor.txt.html()
				if (_this.isHTML) {
					_source = _source.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/ /g, "&nbsp;")
				} else {
					_source = _editor.txt.text().replace(/&lt;/ig, "<").replace(/&gt;/ig, ">").replace(/&nbsp;/ig, " ")
				}
				_editor.txt.html(_source)
			}, */
			seteditor() {
				this.editor = new E(this.$refs.toolbar, this.$refs.editor)
				console.log(this.editor,'editor')
				// 配置菜单
				/* this.editor.config.menus = [
					'head', // 标题
					'indent', //缩进，插件内置
					'bold', // 粗体
					'fontSize', // 字号
					'fontName', // 字体
					'italic', // 斜体
					'underline', // 下划线
					'strikeThrough', // 删除线
					'foreColor', // 文字颜色
					'backColor', // 背景颜色
					'link', // 插入链接
					'list', // 列表
					'justify', // 对齐方式
					'quote', // 引用
					'emoticon', // 表情
					'image', // 插入图片
					'table', // 表格
					'video', // 插入视频
					'code', // 插入代码
					'undo', // 撤销
					'redo', // 重复
					'fullscreen', // 全屏，菜单和编辑区分离时无效
				]

				// 自定义配置颜色（字体颜色、背景色）
				this.editor.config.colors = [
					'#303133',
					'#ffffff',
					'#ff0000',
					'#c00000',
					'#ffc000',
					'#ffff00',
					'#92d050',
					'#00b050',
					'#00b0f0',
					'#0070c0',
					'#002060',
					'#7030a0',
				]

				this.editor.config.uploadImgHooks = {
					fail: (xhr, editor, result) => {
						// 插入图片失败回调
					},
					success: (xhr, editor, result) => {
						// 图片上传成功回调
						console.log(222)
					},
					timeout: (xhr, editor) => {
						// 网络超时的回调
					},
					error: (xhr, editor) => {
						// 图片上传错误的回调
					},
					customInsert: (insertImg, result, editor) => {
						let url = "http://otp.cdinfotech.top" + result.url
						insertImg(url)
					}
				} */
				this.editor.config.onchange = (html) => {
					this.info_ = html // 绑定当前逐渐地值
					this.$emit('change', this.info_) // 将内容同步到父组件中
				}
				// 创建富文本编辑器
				this.editor.create()
			}
		}
	}
</script>

<style lang="css" scoped>
	.editor {
		width: 100%;
		margin: 0 auto;
		position: relative;
		z-index: 0;
	}

	.toolbar {
		border: 1px solid #ccc;
	}

	.text {
		border: 1px solid #ccc;
		min-height: 500px;
		height: 500px;
	}

	/deep/ a {
		color: #428bca;
		text-decoration: none;
	}

	/deep/ a:hover {
		color: #2a6496;
		text-decoration: underline;
	}
</style>
